import DownloadInstallationBillImageButton from './download-installation-bill-image-button.vue';
import EditInstallationResponsibleDialog from './edit-installation-responsible-dialog.vue';
import EditionInstallationAddressDialog from './edit-installation-address-dialog.vue';
import ChangeInstallationOwnerDialog from './change-installation-owner-dialog.vue';
import InstallationStatusSummaryTable from './installation-summary-status.vue';
import SelectInstallationStatus from './installation-status-select.vue';
import SelectGradualInjection from './gradual-injection-select.vue';

export {
  DownloadInstallationBillImageButton,
  EditInstallationResponsibleDialog,
  EditionInstallationAddressDialog,
  InstallationStatusSummaryTable,
  ChangeInstallationOwnerDialog,
  SelectInstallationStatus,
  SelectGradualInjection,
}
